import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import moment from 'moment';
import camelcaseKeys from 'camelcase-keys';

var cc = function cc(o) {
  return camelcaseKeys(o, {
    deep: true
  });
};

var formatDate = function formatDate(date) {
  return moment(date).format('YYYY-MM-DD');
};

var tierRank = {
  bronze: 1,
  silver: 2,
  gold: 3
};
export var parseTier = function parseTier(data) {
  return {
    id: data.id,
    level: data.level,
    minPoints: data.min_points,
    name: data.name
  };
};
export var parseBenefit = function parseBenefit(data) {
  var profileData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    tier: {
      id: 'bronze'
    }
  };
  return _objectSpread({}, cc(data), {
    partner: (data.partner || {}).name,
    tier: (data.tier || {}).name,
    badTier: data.tier && profileData.tier && tierRank[profileData.tier.id] < tierRank[data.tier.id],
    subscriptionPrice: parseInt(data.subscription_price)
  });
};
export var parseBenefits = function parseBenefits(_ref, profileData) {
  var results = _ref.results,
      rest = _objectWithoutProperties(_ref, ["results"]);

  return _objectSpread({
    items: results.map(function (data) {
      return parseBenefit(data, profileData);
    })
  }, rest);
};
export var parseAdditionalBenefits = function parseAdditionalBenefits(items) {
  return items.map(parseBenefit);
};
export var parseEvent = function parseEvent(data) {
  return _objectSpread({}, cc(data), {
    partner: (data.partner || {}).name,
    tier: (data.tier || {}).name,
    date: formatDate(data.date)
  });
};
export var parseEvents = function parseEvents(_ref2) {
  var results = _ref2.results,
      rest = _objectWithoutProperties(_ref2, ["results"]);

  return _objectSpread({
    items: results.map(function (data) {
      return parseEvent(data);
    })
  }, rest);
};
export var parseProfile = function parseProfile(data) {
  return _objectSpread({}, cc(data), {
    name: "".concat(data.first_name, " ").concat(data.last_name),
    number: data.membership_number,
    tier: data.tier && parseTier(data.tier),
    tierExpiry: data.tier_expires,
    paymentMethod: data.payment_method && cc(data.payment_method),
    subscribedBenefits: (data.subscribed_benefits || []).map(function (_ref3) {
      var benefit = _ref3.benefit,
          subscription = _ref3.subscription;
      return {
        benefit: parseBenefit(benefit),
        subscription: cc(subscription)
      };
    })
  });
};